





























































































































































































































import {Vue, Component, Prop} from 'vue-property-decorator'
import {InputSelect} from '@simpli/vue-input'
import {SortOption} from '@/types/SortOption'
import VueMultiselect from 'vue-multiselect/src/Multiselect.vue'
import OrbitCountdown from '@/components/orbit/OrbitCountdown.vue'
import {DateHelper} from '@/helpers/DateHelper'

@Component({
  components: {
    InputSelect,
    VueMultiselect,
    OrbitCountdown,
  },
})
export default class FilterPreviousRoundOrbit extends Vue {
  @Prop({type: Number, required: true}) round!: number
  @Prop({type: Number, required: false}) currentRound?: number
  @Prop({type: Number, default: null})
  earliestClaimDeadlineMs!: number | null

  @Prop({type: Boolean, default: false})
  claimPeriodEnded!: boolean

  roundSelected: {
    $id: number
    field: string
    asc: boolean
    $tag: string
  } | null = null

  get claimEndedAt(): string {
    if (this.earliestClaimDeadlineMs == null) return ''
    return DateHelper.formatDatetime(this.earliestClaimDeadlineMs)
  }

  get currentRoundComputed() {
    return this.currentRound
      ? {
          $id: this.currentRound,
          field: `Round ${this.currentRound}`,
          asc: true,
          $tag: `Round ${this.currentRound}`,
        }
      : null
  }

  get rounds() {
    return Array.from({length: this.round}, (_, i) => i + 1)
      .map(round => ({
        $id: round,
        field: `Round ${round}`,
        asc: true,
        $tag: `Round ${round}`,
      }))
      .sort((a, b) => b.$id - a.$id)
  }

  mounted() {
    if (this.rounds.length > 0) {
      this.roundSelected = this.rounds[0]
    }
  }

  onFilter(option: SortOption) {
    this.$emit('filter', option.$id)
  }
}
